// Public Firebase web config. Safe to ship to the client (it identifies the
// project; Firestore rules and Auth do the actual gating). Kept SDK-free so
// modules that only need the project id or API key (ManagedSeo's REST read)
// do not pull firebase/app into the critical path.
export const firebaseConfig = {
  projectId: 'advantage-horsemanship-web',
  appId: '1:433267426565:web:54f2142ab96053003ce36c',
  storageBucket: 'advantage-horsemanship-web.firebasestorage.app',
  apiKey: 'AIzaSyCrjDk4tTMbymgUFM79RnPJcqJqWlxAPrc',
  authDomain: 'advantage-horsemanship-web.firebaseapp.com',
  messagingSenderId: '433267426565',
  measurementId: 'G-KH2GHN2DPW',
}
